import Section from "./Section";
import PrologueImage from "./PrologueImage";
import BodyCard from "./BodyCard";
import CustomCircularProgress from "./CustomCircularProgress";
import { PageContents } from "../DTOs/responses/pageContents";
import parse from "html-react-parser";
import PrologueImageProps from "../models/prologueImageProps";
import { usePageContents } from "../hooks/usePageContents";
import HtmlContentWrapper from "./HtmlContentWrapper";

interface SimplePageProps {
  prologueImageProps?: PrologueImageProps;
  pageId: string;
  textAlign?: string;
  noCard?: boolean;
  noDivider?: boolean;
  centerTitle?: boolean;
  cardPaddingTop?: number;
  cardPaddingBottom?: number;
  is100?: boolean;
}

function SimpleTextPage({
  prologueImageProps,
  pageId,
  textAlign,
  noCard,
  noDivider,
  centerTitle,
  cardPaddingTop,
  cardPaddingBottom,
  is100,
}: SimplePageProps) {
  const { status, data, error } = usePageContents(pageId);

  return (
    <>
      {prologueImageProps ? <PrologueImage {...prologueImageProps} /> : null}
      {noCard ? (
        <>
          {status === "pending" ? (
            <CustomCircularProgress />
          ) : status === "error" ? (
            <h2>{error.message}</h2>
          ) : (
            data.map((content: PageContents) => (
              <Section
                key={content.contentId}
                content={
                  <HtmlContentWrapper>{parse(content.text)}</HtmlContentWrapper>
                }
                textAlign={textAlign}
                noDivider={noDivider}
                centerTitle={centerTitle}
                title={content.title}
                is100={is100}
              />
            ))
          )}
        </>
      ) : (
        <BodyCard paddingTop={cardPaddingTop} paddingBottom={cardPaddingBottom}>
          {status === "pending" ? (
            <CustomCircularProgress />
          ) : status === "error" ? (
            <h2>{error.message}</h2>
          ) : (
            data.map((content: PageContents) => (
              <Section
                key={content.contentId}
                content={
                  <HtmlContentWrapper>{parse(content.text)}</HtmlContentWrapper>
                }
                textAlign={textAlign}
                noDivider={noDivider}
                centerTitle={centerTitle}
                title={content.title}
                is100={is100}
              />
            ))
          )}
        </BodyCard>
      )}
    </>
  );
}

export default SimpleTextPage;
